/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class VideoService extends __BaseService {
  static readonly VideoPingPath = '/api/Video/Ping';
  static readonly VideoGetStreamKeyPath = '/api/Video/GetStreamKey/{customerId}/{uri}';
  static readonly VideoGetSecureStreamPath = '/api/Video/GetSecureStream/{streamKey}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  VideoPingResponse(): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Video/Ping`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }  VideoPing(): __Observable<Blob> {
    return this.VideoPingResponse().pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `VideoService.VideoGetStreamKeyParams` containing the following parameters:
   *
   * - `uri`:
   *
   * - `customerId`:
   */
  VideoGetStreamKeyResponse(params: VideoService.VideoGetStreamKeyParams): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Video/GetStreamKey/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.uri))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param params The `VideoService.VideoGetStreamKeyParams` containing the following parameters:
   *
   * - `uri`:
   *
   * - `customerId`:
   */
  VideoGetStreamKey(params: VideoService.VideoGetStreamKeyParams): __Observable<string> {
    return this.VideoGetStreamKeyResponse(params).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param streamKey undefined
   */
  VideoGetSecureStreamResponse(streamKey: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Video/GetSecureStream/${encodeURIComponent(String(streamKey))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param streamKey undefined
   */
  VideoGetSecureStream(streamKey: string): __Observable<Blob> {
    return this.VideoGetSecureStreamResponse(streamKey).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module VideoService {

  /**
   * Parameters for VideoGetStreamKey
   */
  export interface VideoGetStreamKeyParams {
    uri: string;
    customerId: number;
  }
}

export { VideoService }
